import React, { useEffect, useContext } from "react";
import styles from "../Profile/Profile.module.css";
import multipleEntry from "../../assests/popup/multipleEntry.svg";
import { useLocation, useNavigate } from "react-router";
import { authentication } from "../../store/firebase-config";
import Context from "../../context/Context";
import { createSearchParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";

function UnAuthorizedUser({}) {
  const { unAuthorizedUser, preview, setUnAuthorizedUser } =
    useContext(Context);
  const { searchParams } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      {unAuthorizedUser && (
        <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10 bg-black backdrop-blur-xl">
          <div className={styles.deteleme}>
            <img
              src={multipleEntry}
              alt=""
              className="w-[56px] h-[56px] mb-[24px]"
            />
            <p className="text-regular-medium px-[20px] mb-[16px] text-[#FFE100]">
              Unauthorized Action Detected
            </p>
            <p className="text-small text-[#CDCDCD] px-[20px]">
              We regret to inform you that an unauthorized action has been
              detected. If you are an organiser, please use the login ID used in
              the dashboard.
            </p>
            <div className="seperator my-[20px]" />
            <div className="flex flex-col gap-[16px] w-[100%]">
              <button
                className="text-regular text-[#1785EB] text-center"
                onClick={() => {
                  authentication.signOut();
                  navigate(
                    {
                      pathname: "/signup",
                      search: `${
                        searchParams ? createSearchParams(searchParams) : ""
                      }`,
                    },
                    {
                      state: {
                        previousLocation: location?.pathname,
                      },
                    }
                  );
                  setUnAuthorizedUser(false);
                }}
              >
                <p className="text-regular-medium">Sign in</p>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UnAuthorizedUser;
